<div class="title-container" fxLayout fxLayoutAlign="space-between center">
  <h1>{{ 'User registration' | translate }}</h1>
  <div class="language-select-container" fxLayout fxLayoutAlign="space-around center">
    <img [src]="languageIconPath"/>
    <select name="languages" [(ngModel)]="selectedLanguage" (change)="onLanguageChange()">
      <option *ngFor="let language of languageSelectorData" [ngValue]="language">
        {{ language.label }}
      </option>
    </select>
  </div>
</div>

<div class="overview-styling">
  <div *ngIf="loading" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>

  <form [formGroup]="form" class="form-container ng user-registration-form" novalidate (ngSubmit)="send(form)">

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label class="control-label" fxFlex="35">
        {{ 'I am' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="getListOfCategories()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          placeholder="{{'Please select...' | translate}}"
          notFoundText="{{'No results found' | translate}}"
          formControlName="customerCategory"
        ></ng-select>
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['customerCategory'].errors && (form.controls['customerCategory'].dirty || form.controls['customerCategory'].touched)">
          <small [hidden]="!form.controls['customerCategory'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
        </div>
      </div>
    </div>
    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="customerName" class="control-label" fxFlex="35">
        {{ 'Customer name' | translate }}
        <span *ngIf="customerNameRequired && !customerNameReadonly">*</span>
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          [readonly]="customerNameReadonly"
          id="customerName"
          maxlength="50"
          class="form-control"
          name="customerName"
          formControlName="customerName">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['customerName'].errors && (form.controls['customerName'].dirty || form.controls['customerName'].touched)">
          <small [hidden]="!form.controls['customerName'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['customerName'].errors.minlength" class="feedback">
            {{ 'Name must be at least 2 characters long' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="customerNumber" class="control-label" fxFlex="35">
        {{ 'Customer number' | translate }}
        <span *ngIf="customerNumberRequired && !customerNumberReadonly">*</span>
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          [readonly]="customerNumberReadonly"
          id="customerNumber"
          maxlength="10"
          class="form-control"
          name="customerNumber"
          formControlName="customerNumber">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['customerNumber'].errors && (form.controls['customerNumber'].dirty || form.controls['customerNumber'].touched)">
          <small [hidden]="!form.controls['customerNumber'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['customerNumber'].errors.pattern" class="feedback">
            {{ 'Customer number must contain only numbers' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label class="control-label" fxFlex="35">
        {{ 'Title' | translate }}
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="getListOfTitles()"
          bindLabel="label"
          bindValue="value"
          [searchable]="false"
          placeholder="{{'Please select...' | translate}}"
          notFoundText="{{'No results found' | translate}}"
          formControlName="salutation">
        </ng-select>
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['salutation'].errors && (form.controls['salutation'].dirty || form.controls['salutation'].touched)">
          <small [hidden]="!form.controls['salutation'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="firstName" class="control-label" fxFlex="35">
        {{ 'First name' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="firstName"
          maxlength="20"
          class="form-control"
          name="firstName"
          formControlName="firstName">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['firstName'].errors && (form.controls['firstName'].dirty || form.controls['firstName'].touched)">
          <small [hidden]="!form.controls['firstName'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['firstName'].errors.minlength" class="feedback">
            {{ 'It should be at least 2 characters long' | translate }}.
          </small>
          <small [hidden]="!form.controls['firstName'].errors.pattern" class="feedback">
            {{ 'It should contain only normal characters' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="lastName" class="control-label" fxFlex="35">
        {{ 'Last name' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="lastName"
          maxlength="40"
          class="form-control"
          name="lastName"
          formControlName="lastName">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['lastName'].errors && (form.controls['lastName'].dirty || form.controls['lastName'].touched)">
          <small [hidden]="!form.controls['lastName'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['lastName'].errors.minlength" class="feedback">
            {{ 'It should be at least 2 characters long' | translate }}.
          </small>
          <small [hidden]="!form.controls['lastName'].errors.pattern" class="feedback">
            {{ 'It should contain only normal characters' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="email" class="control-label" fxFlex="35">
        {{ 'Email address' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="email"
          maxlength="50"

          class="form-control"
          name="email"
          formControlName="email">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['email'].errors && (form.controls['email'].dirty || form.controls['email'].touched)">
          <small [hidden]="!form.controls['email'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['email'].errors.pattern" class="feedback">
            {{ 'Email must have the format john.doe@example.com' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="password" class="control-label" fxFlex="35">
        {{ 'Password' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="password"
          type="password"
          class="form-control"
          formControlName="password">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['password'].errors && (form.controls['password'].dirty || form.controls['password'].touched)">
          <small [hidden]="!form.controls['password'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['password'].errors.minlength" class="feedback">
            {{ 'Should be at least 8 characters long' | translate }}.
          </small>
          <small [hidden]="!form.controls['password'].errors.pattern" class="feedback">
            {{ 'Must contain at least 1 uppercase [A-Z], 1 lowercase [a-z] and 1 character[0-9]' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="confirmPassword" class="control-label" fxFlex="35">
        {{ 'Confirm Password' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="confirmPassword"
          type="password"
          class="form-control"
          formControlName="confirmPassword">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.errors && form.errors.passwordsDoNotMatch && (form.controls['confirmPassword'].dirty || form.controls['confirmPassword'].touched)">
          <small class="feedback">
            {{ 'Passwords do not match' | translate }}.
          </small>
        </div>
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['confirmPassword'].errors && (form.controls['confirmPassword'].dirty || form.controls['confirmPassword'].touched)">
          <small [hidden]="!form.controls['confirmPassword'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label for="phoneNumber" class="control-label" fxFlex="35">
        {{ 'Phone number' | translate }}
        <span *ngIf="phoneNumberRequired">*</span>
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="phoneNumber"
          maxlength="20"
          class="form-control"
          name="phoneNumber"
          formControlName="phoneNumber">
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['phoneNumber'].errors && (form.controls['phoneNumber'].dirty || form.controls['phoneNumber'].touched)">
          <small [hidden]="!form.controls['phoneNumber'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['phoneNumber'].errors.pattern" class="feedback">
            {{ 'Please enter a valid phone number' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label class="control-label" fxFlex="35">
        {{ 'PostalCode' | translate }}
        <span *ngIf="postalCodeRequired">*</span>
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <input
          id="postalCode"
          maxlength="10"
          class="form-control"
          name="postalCode"
          formControlName="postalCode">

        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['postalCode'].errors && (form.controls['postalCode'].dirty || form.controls['postalCode'].touched)">
          <small [hidden]="!form.controls['postalCode'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
          <small [hidden]="!form.controls['postalCode'].errors.pattern" class="feedback">
            {{ 'PostalCode format not valid' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label class="control-label" fxFlex="35">
        {{ 'Country' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="getListOfCountries()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [minTermLength]="3"
          placeholder="{{'Please select...' | translate}}"
          notFoundText="{{'No results found' | translate}}"
          formControlName="countryCode">
        </ng-select>
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['countryCode'].errors && (form.controls['countryCode'].dirty || form.controls['countryCode'].touched)">
          <small [hidden]="!form.controls['countryCode'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <div class="form-group" fxLayout="row" fxLayout.xs="column">
      <label class="control-label" fxFlex="35">
        {{ 'Spoken language' | translate }} *
      </label>
      <div class="input-container" fxLayout="column" fxFlex>
        <ng-select
          [items]="getListOfLanguages()"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          placeholder="{{'Please select...' | translate}}"
          notFoundText="{{'No results found' | translate}}"
          formControlName="language">
        </ng-select>
        <div fxLayout="column" class="feedback-wrapper"
             *ngIf="form.controls['language'].errors && (form.controls['language'].dirty || form.controls['language'].touched)">
          <small [hidden]="!form.controls['language'].errors.required" class="feedback">
            {{ 'Required' | translate }}.
          </small>
        </div>
      </div>
    </div>

    <!-- Temporarily disabled (https://itsm.slx.de/jira/browse/UMNG-552) -->
    <!--div fxLayout="row" fxLayout.xs="column">
      <div fxFlex="35"></div>
      <div class="checkbox" fxFlex>
        <label class="control-label">
          <input
            id="subsribeToNewsletter"
            type="checkbox"
            name="subsribeToNewsletter"
            formControlName="subsribeToNewsletter">
          {{'Subscribe to Newsletter' | translate}}.
        </label>
      </div>
    </div-->

    <div fxLayout="row" fxLayout.xs="column">
      <div fxFlex="35"></div>
      <div class="checkbox" fxFlex>
        <label class="control-label">
          <input
            id="privacy"
            type="checkbox"
            name="privacy"
            formControlName="privacy">
          <span *ngIf="getDataPrivacyNotice() | async as dataPrivacyNotice">
            {{ dataPrivacyNotice.prefix }}
            <a href="{{dataPrivacyNotice.link}}" target="_blank">
              <span class="link">{{ dataPrivacyNotice.protectionProvision}}</span>{{ addWhitespacePrefixIfNotDot(dataPrivacyNotice.suffix) }}
            </a>
          </span>
        </label>
      </div>
    </div>

    <div class="row justify-content-center">
      <button type="submit" class="btn btn-primary" [disabled]="!form.valid">
        {{ 'Submit' | translate }}
      </button>
    </div>

    <div class="divider"></div>

  </form>
</div>
